<template>
  <ChipsField
    id="cbord-multiple-terminal-id"
    name="terminal_id"
    :label="translate(`${LOCALE_PREFIX}.form.multipleTerminalId`)"
    :placeholder="translate(`${LOCALE_PREFIX}.form.multipleTerminalIdPlaceholder`)"
    :disabled="!editMealPlan"
    :addOnBlur="true"
  />
</template>

<script setup lang="ts">
import { useTranslation } from '@centric-os/helpers';
import { storeToRefs } from 'pinia';
import { SitesLocalePrefix } from '../../../../../../enums';
import { useFinancialConfigStore } from '../../../../../../routes';

// Set localization
const { translate } = useTranslation();
const LOCALE_PREFIX = SitesLocalePrefix.SITE_MEAL_PLAN;

// Set financial config store
const fConfigStore = useFinancialConfigStore();
const { editMealPlan } = storeToRefs(fConfigStore);
</script>
